<app-role-selector
  [rolesParent]="rolesForRoleSelector"
  [preSelectRolesIds]="rolesForRoleSelector"
  [isRequired]="true"
  [splitRoles]="splitRoles"
  (handleCheckRoles)="setRolesValue($event)"
>
</app-role-selector>
